import { Module } from "@interfaces/fc-user/permissions"
import { AppointmentI } from "@interfaces/scheduller/appointmentsI"
import { setCalendarHeaderOfficeFilterState, setCalendarHeaderServiceFilterState, setCalendarHeaderStatusFilterState, setCalendarHeaderViewState } from "@redux/slices/calendar/header/calendar-header.slice"
import { RootState } from "@redux/store"
import dayjs from "dayjs"
import i18next from "i18next"
import { CSSProperties, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

interface MenuItemProps {
    currentRoles: string[]
    accessRoles: string[]
    isActive?: boolean
    navigate: (route: string) => void
    route: string
    label: string
    iconName: string
    module: Module
}

const MenuItem = (props: MenuItemProps) => {
    const { currentRoles, accessRoles, isActive, navigate, route, label, iconName } = props
    const history = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation(['mySchedule','calendar'])
    const lang = i18next.language;
    const permissions = useSelector((state: RootState) => state.permission.permission);
    const practitionerAppointmentsToBeConfirmed = useSelector((state: RootState) => state.practitionerAppointmentsToBeConfirmed);
    const CalendarHeaderRe = useSelector((state: RootState) => state.calendarHeaderRe);
    const [titleText, setTitleText] = useState<string>('')
    const [totalAppoimentsTobeConfirmed, setTotalAppoimentsToBeConfirmed] = useState<number>(0)
    const numberActive:CSSProperties  = {
        fontSize: "12px",
        fontWeight: "bold",
        backgroundColor: "#f15a5a",
        padding: "0px",
        cursor: "pointer"
    };
    useEffect(()=>{
        if (route === "/practitioner/calendar") {
            if (practitionerAppointmentsToBeConfirmed.practitionerAppointmentsToBeConfirmed.length > 0) {
                let newArray:AppointmentI[] = []
                practitionerAppointmentsToBeConfirmed.practitionerAppointmentsToBeConfirmed.forEach((appointment, index) => {
                    newArray[index] = { ...appointment }
                })
                newArray = newArray.sort(((a, b) => a.appointmentDateTimestamp - b.appointmentDateTimestamp))
                let countConfirmed = 0,textDate = "";
                newArray.map((appoiment: AppointmentI, i) => {
                    if (appoiment.statusAppointment === "toBeConfirmed") {
                        if(countConfirmed === 0){
                            const appointmentDay = dayjs(new Date(appoiment.appointmentDateString)).format('D')
                            const appointmentMonth = t(`calendar:monthsAbbreviated.${dayjs(new Date(appoiment.appointmentDateString)).format('MMM').toUpperCase()}.long`)
                            const appointmentYear = dayjs(new Date(appoiment.appointmentDateString)).format('YYYY')
                            const appointmentDate = appointmentDay + "-" + appointmentMonth + "-" + appointmentYear
                            textDate = appointmentDate
                        }
                        countConfirmed++
                        if (newArray.length === (i + 1)) {
                            const appointmentDay = dayjs(new Date(appoiment.appointmentDateString)).format('D')
                            const appointmentMonth = t(`calendar:monthsAbbreviated.${dayjs(new Date(appoiment.appointmentDateString)).format('MMM').toUpperCase()}.long`)
                            const appointmentYear = dayjs(new Date(appoiment.appointmentDateString)).format('YYYY')
                            const appointmentDate = appointmentDay + "-" + appointmentMonth + "-" + appointmentYear
                            setTitleText(`${t(`mySchedule:appointmentsToBeConfirmed.textRange.of`)} ${textDate} ${t(`mySchedule:appointmentsToBeConfirmed.textRange.to`)} ${appointmentDate}`)
                        }
                    }
                    return countConfirmed
                })
                setTotalAppoimentsToBeConfirmed(countConfirmed)
            } else {
                setTotalAppoimentsToBeConfirmed(0)
            }
        }
        // eslint-disable-next-line 
    },[practitionerAppointmentsToBeConfirmed, lang])

    // if(!accessRoles.some((role) => currentRoles.some((r) => r === role)) || accessRoles.length === 0) {
    //     return null
    // }
    if(permissions.length > 0){
        let auth = false;
        const role = permissions.find(r => r.permission === props.module)
        if(role && role.level !== 'none'){
            auth= true
        }
        if(auth === false){
            return null
        }
    }    
    const goCalendar = () =>{
        dispatch(setCalendarHeaderStatusFilterState({
            statusFilter:'toBeConfirmed'
        }));
        dispatch(setCalendarHeaderViewState({
            viewFilter:'schedule'
        }));
        dispatch(setCalendarHeaderOfficeFilterState({
            officeFilter:"schedule"
        }));
        dispatch(setCalendarHeaderServiceFilterState({
            serviceFilter:'schedule'
        }));
        history('/practitioner/calendar');
    }
    return(
        <div
            className={isActive ? 'Menu__SectionsItem-Active' : 'Menu__SectionsItem'}
            data-testid="profile-navigation"
            onClick={() => navigate(route)}
        >
            <div className="Menu__SectionsItemIcon"> 
                <em className={iconName}></em>
            </div>
            {route === "/practitioner/calendar" ?
                <>
                <p className="Menu__SectionsItemText">{label}</p>
                {totalAppoimentsTobeConfirmed > 0 &&
                <span className="Calendar__DayNumber-Active" title={titleText}style ={numberActive} onClick={() => goCalendar()}>{totalAppoimentsTobeConfirmed}</span>
                }
                </>
                :
                <p className="Menu__SectionsItemText">{label}</p>
            }
        </div>
    )
}

export default MenuItem